export const formatServiceDuration = (durationMinutes: number | null | undefined): string => {
  if (durationMinutes == null || durationMinutes <= 0) {
    return '';
  }

  return ` (${durationMinutes} min)`;
};
